export const formatCurrency = (value, currency = '') => {
  const splitValue = value.toString().split('.');
  const mainValue = _format(splitValue[0]);
  const fraction = splitValue[1] ? `.${splitValue[1]}` : '';

  return `${mainValue}${fraction} ${currency.toUpperCase()}`;
};

export const format = (value, decimals, hideFractionIfPossible = true, separator) => {
  const splitValue = cutAmount(value, decimals).split('.');
  let fraction = '';
  if (decimals === 2) {
    if (!hideFractionIfPossible || parseFloat(splitValue[1]) !== 0) {
      fraction = '.' + splitValue[1];
    }
  } else if (decimals > 0 && parseFloat(splitValue[1]) !== 0) {
    fraction = '.' + splitValue[1].replace(/0*$/, '');
  }
  const mainValue = _format(splitValue[0], separator);

  return `${mainValue}${fraction}`;
};

function _format(value, separator = ' ') {
  let result = [];
  for (let i = value.length - 1; i >= 0; i--) {
    if (i !== value.length - 1 && (value.length - 1 - i) % 3 === 0) result.unshift(separator);
    result.unshift(value[i]);
  }
  return result.join('');
}

export const cutAmount = (value, decimals) => {
  const factor = 10 ** decimals;

  const raw      = value * factor;
  const truncRaw = Math.trunc(raw);
  const frac     = raw - truncRaw;
  const fudge    = Number.EPSILON * Math.abs(raw);

  let finalRaw = truncRaw;
  if      (raw >  0 && frac >  1 - fudge) finalRaw = truncRaw + 1;
  else if (raw <  0 && frac < -1 + fudge) finalRaw = truncRaw - 1;
  const result = finalRaw / factor;
  return (Object.is(result, -0) ? 0 : result).toFixed(decimals);
};
